import { IServiceQueryProps } from './../interfaces/IHttpsServices';
import { httpServices } from './httpServices';
import {
  GLOBALIZATION_SYSTEM_ID,
  GLOBALIZATION_BASE_API_URL,
  GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT,
  GLOBALIZATION_GET_CULTURES_ENDPOINT,
} from '../constants/globalizationConstants';
import i18next from 'i18next';
import { apiService } from '../utils';
import { signinSilent } from './authService';

const { getGlobalization } = httpServices;
const systemId = GLOBALIZATION_SYSTEM_ID;

const globalizationGetServices = ({
  key,
  url,
  params,
  successCallbackFunc,
  hasCulture,
  retry = false,
  errorCallbackFunc,
}: IServiceQueryProps) => {
  const {
    data = [],
    isFetching,
    error,
    refetch,
  } = getGlobalization({
    key,
    url: apiService(GLOBALIZATION_BASE_API_URL) + url,
    params,
    successCallbackFunc,
    errorCallbackFunc,
    hasCulture,
    retry,
  });

  return {
    translations: data,
    error,
    isLoading: isFetching,
    refetch,
  };
};

const getTranslationsByTag = (
  tag: string,
  successCallbackFunc?: (args: unknown) => void,
  retry: boolean = false
) => globalizationGetServices({
  key: ['translations', i18next.language, tag],
  url: GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT,
  successCallbackFunc,
  hasCulture: true,
  retry,
  errorCallbackFunc: (error) => {
    if (retry && error === 401) {
      signinSilent();
    }
  },
  params: {
    SystemId: systemId,
    Tag: tag,
    Culture: i18next.language,
  },
});

const getTranslationsByTagUserNotLogged = (
  tag: string,
  successCallbackFunc?: (args: unknown) => void,
  enabled?: boolean,
  culture = i18next.language
) => globalizationGetServices({
  key: ['translations', culture, tag],
  url:
    'user-not-logged/' +
    GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT,
  successCallbackFunc,
  hasCulture: true,
  enabled,
  params: {
    SystemId: systemId,
    Tag: tag,
    Culture: culture,
  },
});

const getCultures = () => {
  return globalizationGetServices({
    key: ['cultures', i18next.language],
    url: GLOBALIZATION_GET_CULTURES_ENDPOINT,
    params: {
      itensPerPage: 100,
    },
  });
};

export const globalizationService = {
  getTranslationsByTag,
  getCultures,
  getTranslationsByTagUserNotLogged,
};
